/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useFormatStatusEventDateTime } from '../useFormatStatusEventDateTime';

const { Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const LoadingPointMobile = ({ className, ticket, plantAddress, loadingStarted }) => {
  const formatTicketDateTime = useFormatStatusEventDateTime({ mode: 'datetime' });

  return (
    <Styled className={cn('loading-point', className)}>
      <Subtitle>
        <Translate stringId="loadingPoint" data-testid="loadingPointLabel" />
      </Subtitle>
      <div className="label">
        <Translate stringId="plantName" data-testid="plantNameLabel" />:{' '}
      </div>
      <span data-testid="plantNameValue">{ticket?.origin?.description}</span>
      <div className="label">
        <Translate stringId="plantAddress" data-testid="plantAddressLabel" />:{' '}
      </div>
      <span data-testid="plantAddressValue">{plantAddress}</span>
      <div className="label">
        <Translate stringId="loadingScheduleStart" data-testid="loadingScheduleStartLabel" />:{' '}
      </div>
      <span style={{ whiteSpace: 'nowrap' }} data-testid="loadingScheduleStart">
        {formatTicketDateTime(loadingStarted)}
      </span>
    </Styled>
  );
};

export default LoadingPointMobile;
